module.exports = __webpack_public_path__ + "static/media/notFilesFound.7d71d480.svg";